import { defineStore } from 'pinia';
import { usePosShopStore } from './pos.shop';
import { usePosEmployeesStore } from './pos.employees';
import { usePosReceiptsStore } from './pos.receipts';
import { JobAction } from '~/interface/job';
import dayjs from 'dayjs';
import _ from "lodash"
import { computeDrawer } from '~/composables/useDrawer';
import { useSettingsStore } from './settings';
import { usePaymentSummary } from '~/composables/usePaymentSummary';
import ThermalPrintOrderSummary from '~/class/printer/ThermalPrintOrderSummary';
import ThermalPrintProductSummary from '~/class/printer/ThermalPrintProductSummary';
import ThermalPrintStock from '~/class/printer/ThermalPrintStock';
export const useReportStore = defineStore('report', {
  state: () => ({
 
  }),

  getters: {
    // Example getter:
    // isLoggedIn: (state) => !!state.currentUser,
  },

  actions: {
    printSummary({isFullReport=false, receiptsPayload=[], startDatePayload=null, actualCash=0, isCloseShop=false, isLocalOnly=false, isChangeShift=false, outstanding=null}) {
      //excute receipt
      const receiptsStore = usePosReceiptsStore();
      const shopStore = usePosShopStore();
      const settingsStore = useSettingsStore()
      const employeeStore = usePosEmployeesStore();
      const jobsStore = usePosJobsStore()      
      let receipts = receiptsStore.receipts;   

      if(receiptsPayload.length>0){
        receipts = receiptsPayload
      }
      

      const jobs = Object.values(jobsStore.jobs);
      const shopOpenJob = jobs.find((job) => job.type == JobAction.OPEN_SHOP);
      
      const drawer = useComputeDrawer().excute(jobsStore.jobs, receipts, actualCash);
      const paymentSummaryList = usePaymentSummary(receipts).summary.value;

      const drawerData = {
        ...drawer,
      };

      const payload = {
        store: { name: settingsStore.getStoreName() },
        employee: employeeStore.getCurrentEmployee,
        receipts: receipts,
        drawerData,
        isFullReport: isFullReport,
        isCloseShop: isCloseShop,
        isChangeShift: isChangeShift,
        outstanding: outstanding,
        isLocalOnly: isLocalOnly,
        startDate: shopOpenJob?.timestamp,
        paymentSummaryList,
      };

      console.log('printSummary...', payload);

      return payload
    },

    printOrderSummary({receiptsPayload=[], reportDateText='', reportTimeText='all day'}: {receiptsPayload?: any[], reportDateText?: string, reportTimeText?: string}) {
      const receiptsStore = usePosReceiptsStore();
      const settingsStore = useSettingsStore();
      const employeeStore = usePosEmployeesStore();
      let receipts = receiptsStore.receipts;

      if (receiptsPayload.length > 0) {
        receipts = receiptsPayload;
      }

      const payload = {
        store: { name: settingsStore.getStoreName() },
        employee: employeeStore.getCurrentEmployee,
        receipts,
        reportDateText,
        reportTimeText,
      };

      new ThermalPrintOrderSummary('/printcustom').printOrderSummary(payload).print();
      console.log('printOrderSummary...', payload);  
    },

    printProductSummary(payload: {
      storeName: string
      fromText: string
      toText: string
      reportName?: string
      printedAtText?: string
      topCommentText?: string
      totalAmount: number
      byType: Array<{ label: string; value: number }>
      details?: Array<{
        typeName: string
        productName: string
        total: number
        subs: Array<{ name: string; qty: number; amount: number }>
      }>
      sumProductType?: Array<{ name: string; groupByType: Record<string, any> }>
    }) {
      new ThermalPrintProductSummary('/printcustom').printProductSummary(payload as any).print();
      console.log('printProductSummary...', payload);
    },

    printStockMovement(payload: {
      storeName: string
      dateFrom: string
      dateTo: string
      lengthDays: number
      printAtShort?: string
      printAtLong?: string
      reportName?: string
      groups: Array<{
        name: string
        rows: Array<{
          name: string
          unit?: string
          category?: string
          begin: number
          add: number
          sold: number
          balance: number
        }>
      }>
    }) {
      new ThermalPrintStock('/printcustom').printStockMovement(payload as any).print();
      console.log('printStockMovement...', payload);
    },

    printProductSold({isFullReport=false, reportProductSummary={}, isCloseShop=false, isChangeShift=false}: {isFullReport?: boolean, reportProductSummary?: any, isCloseShop?: boolean, isChangeShift?: boolean}){
      //excute receipt      
      const jobStore = usePosJobsStore();
      const employeeStore = usePosEmployeesStore();
      const receiptsStore = usePosReceiptsStore();
      const productStore = usePosProductsStore()
      const settingsStore = useSettingsStore()
      const productReport = useProductReport()      
      

      const jobs = Object.values(jobStore.jobs)
      const shopOpenJob = jobs.find((j:any)=>j.action == JobAction.OPEN_SHOP)
      const decodeRow = (row: any, fallbackKey?: string) => {
        // tuple shape: [subId, name, quantity, amount, percent]
        if (Array.isArray(row)) {
          const id = String(row?.[0] ?? fallbackKey ?? '').trim()
          if (!id) return null
          return {
            id,
            value: {
              name: String(row?.[1] ?? ''),
              quantity: Number(row?.[2] ?? 0),
              amount: Number(row?.[3] ?? 0),
            },
          }
        }
        // object shape: { name, quantity, amount } (already decoded)
        if (row && typeof row === 'object') {
          const id = String(row?.subItemId ?? row?.id ?? fallbackKey ?? '').trim()
          if (!id) return null
          return {
            id,
            value: {
              name: String(row?.name ?? ''),
              quantity: Number(row?.quantity ?? 0),
              amount: Number(row?.amount ?? 0),
            },
          }
        }
        return null
      }

      const normalizeReportProductSummary = (src: any) => {
        const acc: Record<string, { name: string; quantity: number; amount: number }> = {}
        if (!src) return acc
        // API shape: object keyed by subId, value = tuple [subId, name, qty, amount, percent]
        if (!Array.isArray(src) && typeof src === 'object') {
          for (const [key, row] of Object.entries(src)) {
            const decoded = decodeRow(row, key)
            if (decoded) acc[decoded.id] = decoded.value
          }
          return acc
        }
        // Array of rows (tuple or object)
        if (Array.isArray(src)) {
          for (const row of src) {
            const decoded = decodeRow(row)
            if (decoded) acc[decoded.id] = decoded.value
          }
          return acc
        }
        return acc
      }

      const normalizedSummary = normalizeReportProductSummary(reportProductSummary)
      const hasSummaryData = normalizedSummary && Object.keys(normalizedSummary).length > 0
      const goodReceipts = (receiptsStore.receipts || []).filter((r: any) => !r?.IsDeleted)
      const productReportData = hasSummaryData
        ? productReport.catalogMapping(productStore.catalogs, normalizedSummary)
        : productReport.execute(productStore.catalogs, goodReceipts)


      //SUM BY TYPE
      const calProductByType = productReport.sumProductByType(productReportData)
      const sumProductType = productReport.calcPercentProductTypeAndSort(calProductByType)
  

      //For print
      const payload = {
        store: {name:settingsStore.getStoreName()},
        employee:employeeStore.getCurrentEmployee,
        productsTypeHolder:productStore.getProductTypeHolderWithCatalogId, //old version
        isFullReport,
        isCloseShop,
        isChangeShift,
        startDate:shopOpenJob?.timestamp,
        productReportData,
        sumProductType
       }

       console.log("payload=>", payload)
      
      return payload
    },

    printVoidItems({isCloseShop=false, isChangeShift=false}: {isCloseShop?: boolean, isChangeShift?: boolean} = {}){
      const shopStore = usePosShopStore();
      const employeeStore = usePosEmployeesStore();      
      const jobsStore = usePosJobsStore()

      const jobs = Object.values(jobsStore.jobs)
      const voidItemsJob = jobs.filter((j:any)=>j.type == JobAction.VOID || j.type == JobAction.VOID_TOPPING)
      
      let voidItemsList = []
      for(let job of voidItemsJob){
        // json2 carries the per-uuid void qty (negative) — this is the real
        // amount that was voided. Never use the raw line qty: a SKU ordered
        // several times merges into ONE cart line, so item.quantity is the
        // whole-line total (e.g. โซดา 2+3+4=9) while json2 says the void was 1.
        // Fall back to the line qty only when a json2 entry is missing.
        const json2:Record<string, any> = job?.json2 || {}
        for(let item of job?.__items || []){
          const negQty = Number(json2[item.uuid] || 0)
          const quantity = Math.abs(negQty || item.quantity || 0)
          voidItemsList.push({subItemId:item.subItemId, name:item.name, quantity, table:job.alias, timestamp:job.timestamp, price:item?.price || 0})
        }
      }


      //SORT BY TIMESTAMP
      voidItemsList = _.orderBy(voidItemsList, ['timestamp'], ['asc'])
      const voidAmount = _.reduce(voidItemsList, (sum, item) => sum + item.quantity * item.price || 0, 0)

      //For print
      const payload = {
        store: shopStore.data,
        employee:employeeStore.getCurrentEmployee,
        voidItemsList,
        voidAmount,
        isCloseShop,
        isChangeShift,
      }
      
      console.log('printVoid...', payload);
      return payload
    },

    printOpenMenu({isCloseShop=false, isChangeShift=false}: {isCloseShop?: boolean, isChangeShift?: boolean} = {}){
      const settingsStore = useSettingsStore()
      const receiptsStore = usePosReceiptsStore();
      const employeeStore = usePosEmployeesStore();
      const receipts = receiptsStore.receipts;

      const payload = {
        store: {name:settingsStore.getStoreName()},
        employee:employeeStore.getCurrentEmployee,
        receipts,
        isCloseShop,
        isChangeShift,
      }
      
      console.log('printOpenMenu...', payload);
      return payload
    },   
  },
});
